/**
 * Vuex actions for managing work days.
 * @module store/admin/settings/workDays/actions
 */

export default {

  /**
   * Create a new work day.
   * @async
   * @function create
   * @param {Object} context - Vuex action context.
   * @param {Object} data - Data for the new work day.
   * @returns {Promise} Promise representing the HTTP request.
   */
  async create({ commit }, data) {
    commit('loadingStart', null, { root: true });
    return await this._vm.$http
      .post(`work-days/create`, data)
      .then((response) => {
        if (response.status === 200) {

          commit('setData', response.data.data);
          commit('loadingFinish', null, { root: true });

        }
      })
      .catch((error) => {

        if (error.response.status === 405) {
          commit('failMessage', 'max_work_shifts', { root: true });
        }

        commit('loadingFinish', null, { root: true });
        throw error;
      });
  },

  /**
   * Get all work days.
   * @async
   * @function get
   * @param {Object} context - Vuex action context.
   * @returns {Promise} Promise representing the HTTP request.
   */
  async get({ commit }) {
    commit('loadingStart', null, { root: true });
    return await this._vm.$http
      .get(`work-days`)
      .then((response) => {
        if (response.status === 200) {
          commit('setData', response.data.data);

          commit('loadingFinish', null, { root: true });

        }
      })
      .catch((error) => {
        commit('loadingFinish', null, { root: true });
        throw error;
      });
  },

  /**
   * Toggle a work day.
   * @async
   * @function toggle
   * @param {Object} context - Vuex action context.
   * @param {Object} data - Data for the work day to toggle.
   * @returns {Promise} Promise representing the HTTP request.
   */
  async toggle({ commit }, data) {
    commit('loadingStart', null, { root: true });
    return await this._vm.$http
      .post(`work-days/toggle`, data)
      .then((response) => {
        if (response.status === 200) {

          commit('setData', response.data.data);
          commit('loadingFinish', null, { root: true });

        }
      })
      .catch((error) => {
        commit('loadingFinish', null, { root: true });
        throw error;
      });
  },

  /**
   * Delete a work day.
   * @async
   * @function delete
   * @param {Object} context - Vuex action context.
   * @param {string} id - ID of the work day to delete.
   * @returns {Promise} Promise representing the HTTP request.
   */
  async delete({ commit }, id) {
    commit('loadingStart', null, { root: true });
    return await this._vm.$http
      .post(`work-days/delete/${id}`)
      .then((response) => {
        if (response.status === 200) {

          commit('setData', response.data.data);
          commit('loadingFinish', null, { root: true });

        }
      })
      .catch((error) => {
        commit('loadingFinish', null, { root: true });
        throw error;
      });
  }


};
